import React, { useState, useEffect } from "react";
import { array, bool, func } from "prop-types";
import { useNavigate } from 'react-router-dom';
import { APPCONFIG } from '@/app.config';
import { USER_TOKEN } from '@Config/userToken';
import './styles.scss';

function NotificationCounter({ data = [], visible = false, onChange = null }) {
  const navigate = useNavigate();

  let listMessages = data.map(item => {
    return { ...item, active: true };
  });

  const [state, setState] = useState({
    listMessages: listMessages,
    controlVisible: visible,
    messagesVisible: false
  });

  useEffect(() => {
    let listMessages = data.map(item => {
      return { ...item, active: true };
    });

    setState(prev => ({
      ...prev,
      listMessages: listMessages,
      controlVisible: visible
    }));
  }, [data, visible]);

  function ShowMessages() {
    setState({ ...state, messagesVisible: true });
  }
  function HideMessages() {
    setState({ ...state, messagesVisible: false });
  }
  function VerifyMessage(id) {
    if (onChange !== null) {

      let stateNew = { ...state };
      let item = stateNew.listMessages.find(i => i.id === id);
      if (item) item.active = false;
      setState({ ...stateNew });

      onChange(id);
    }
  }
  function GetUrlAttach(id) {
    const userToken = USER_TOKEN.get();
    const AccessToken = userToken.token;
    const RefreshToken = userToken.refreshToken;

    const download_url = APPCONFIG.ENDPOINTS.PRODUCERURL + `api/FileRepository/Download/NotificationAttach/${id}?RefreshToken=${RefreshToken}&AccessToken=${AccessToken}`;
    return download_url;
  }
  function ClickCounter() {
    if (state.messagesVisible)
      HideMessages();
    else
      ShowMessages();
  }

  function ClickTitle(index) {
    let item = state.listMessages[index];
    if (item.body.length > 0) {
      item.showBody = !item.showBody;
      setState({ ...state, listMessages: state.listMessages });
    }
  }

  function handleHistorial() {
    navigate('/historialnotificaciones');
  }


  return (

    <React.Fragment>
      {state.controlVisible &&
        <div className={"counter-div"} >
          <a className={"counter-info"} href="#" onClick={ClickCounter} >
            <i className={"counter-icon bi bi-bell"} ></i>
            {
              (state.listMessages.length > 0) && <span className={"label counter-label"} >{state.listMessages.length}</span>
            }
          </a>
          {state.messagesVisible &&
            <ul className={"counter-dropdown dropdown-menu"}>

              <li>
                <div className={"dropdown-messages-box dropdown-messages-close"} >
                  <button type="button" className={"pull-right notification-icon-btn"} onClick={e => HideMessages()} aria-label="Cerrar notificaciones"><i className={"bi bi-chevron-up"} aria-hidden="true"></i></button>
                </div>
              </li>
              {
                (state.listMessages.length > 0) ?
                  state.listMessages.map(function (item, index) {

                    return <li key={item.id}>
                      <div className={"dropdown-messages-box"}>
                        <a className={"pull-left"}><i className={"bi bi-envelope"} aria-hidden="true"></i></a>
                        <div>
                          <button
                            type="button"
                            className={(item.body.length > 0 || item.link.length > 0) ? "counter-title counter-title-con-contendio" : "counter-title"}
                            title={(item.title.length > 45) ? item.title : ""}
                            onClick={e => ClickTitle(index)}
                          >
                            {(item.title.length > 45) ? item.title.toString().substring(0, 45) + "..." : item.title}
                          </button>
                          <a className={"pull-right"} title='Marcar como vista'>
                            <i className={(item.active) ? "bi bi-x counter-verify" : "bi bi-arrow-clockwise counter-verify"} aria-hidden="true"
                              onClick={e => { if (item.active) VerifyMessage(item.id) }}></i>
                          </a>
                          {item.link && (
                            <a className={"pull-right"} title='Ver archivo adjunto'
                              href={GetUrlAttach(item.id)} target="_blank">
                              <i className={"bi bi-paperclip counter-verify"} aria-hidden="true"></i>
                            </a>
                          )}
                        </div>
                        {item.showBody && item.body.length > 0 &&
                          <div className={"counter-body"} dangerouslySetInnerHTML={{ __html: item.body }} />
                        }
                      </div>
                      {
                        (index + 1 < state.listMessages.length) && <div className={"divider"}></div>
                      }
                    </li>

                  })
                  :
                  <li>
                    <div className={"text-center"}>
                      <div>
                        <span className={"counter-empty"}>Sin notificaciones pendientes</span>
                      </div>
                    </div>
                  </li>
              }
              <li>
                <div className={"counter-historial text-center"}>
                  <hr />
                  <button
                    type="button"
                    onClick={e => handleHistorial()}
                    className={"counter-title"}>Ver historial de notificaciones</button>
                </div>
              </li>

            </ul>
          }
        </div>
      }
    </React.Fragment>

  );

}

NotificationCounter.propTypes = {
  data: array,
  visible: bool,
  onChange: func
};


export default NotificationCounter;
